import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useGameVersion } from '../contexts/GameVersionContext';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export default function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { isAuthenticated, loading, permission } = useAuth();
  const { gameVersion } = useGameVersion();

  if (loading) {
    return (
      <div className="min-h-screen bg-dark flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${gameVersion}/login`} replace />;
  }

  if (requireAdmin && permission !== 'ADMIN') {
    return <Navigate to={`/${gameVersion}`} replace />;
  }

  return <>{children}</>;
}